import React, { useEffect } from "react";
import CMSContactInfoListing from "./CMSContactInfoListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
  setIsOpenEditDialog,
} from "src/redux/slices/ContactInfoSlice";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import EditContactInfoWrapper from "../Edit/EditContactInfoWrapper";
import { useGetCMSByTypeQuery } from "src/services/CMSService";
import { usePermission } from "src/hooks/usePermission";

type Props = {};

const CMSContactInfoListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isTableLoading,
    isOpenEditDialog,
  } = useSelector((state: RootState) => state.contactInfo);

  const { data, isLoading, isFetching }: any =
    useGetCMSByTypeQuery("CONTACT_INFO");

  // Setting Module Data
useEffect(() => {
  if (isLoading || isFetching) {
    dispatch(setIsTableLoading(true));
  } else {
    // 🔹 Add `isActive: true` to every item before storing
    const updatedItems = (data?.data || []).map((item: any) => ({
      ...item,
      isActive: true,
    }));

    dispatch(setItems(updatedItems));
    dispatch(setIsTableLoading(false));
    dispatch(setTotalItems(data?.totalItem || 0));
  }
}, [data, isLoading, isFetching, dispatch]);

  const moduleName = "CMS";

  const canEdit = usePermission(moduleName, "UPDATE");
  const columns: columnTypes[] = [
    {
      field: "phoneNumber",
      headerName: "Phone Numbers",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => {
        const numbers = Array.isArray(row?.phoneNumber)
          ? row?.phoneNumber
          : row?.phoneNumber
          ? [row?.phoneNumber]
          : [];

        return numbers?.length > 0 ? numbers?.join(", ") : "No Numbers Added";
      },
    },
    {
      field: "address",
      headerName: "Address",
      flex: "flex-[1_1_0%]",
    },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[0.5_1_0%]",
      align: "center",
      renderCell: (row: any) => {
        const options = [];

        if (canEdit) {
          options.push({
            label: "Edit",
            onClick: () => {
              dispatch(setIsOpenEditDialog(true));
            },
          });
        }
        return <ATMMenu options={options} />;
      },
    },
  ];

  return (
    <div>
      <CMSContactInfoListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />

      {/* Edit Contact Dialog */}
      {isOpenEditDialog && (
        <EditContactInfoWrapper
          onClose={() => {
            dispatch(setIsOpenEditDialog(false));
          }}
        />
      )}
    </div>
  );
};

export default CMSContactInfoListingWrapper;
